// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  eventId: __t.u64().primaryKey().name("event_id"),
  assetId: __t.u64().name("asset_id"),
  actor: __t.identity(),
  action: __t.string(),
  detail: __t.string(),
  at: __t.timestamp(),
});
